import React from 'react';
import styled from 'styled-components';

import { createCompany, updateCompany } from '../../../../services/lwadmin/company/company-service';
import CompaniesContext from './context';
import MemberSearchControl from './member-search-control';

const MemberTitle = styled.div`
  font-size: 16px;
`;

const Members = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 8px;
`;

const Member = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

/* eslint-disable complexity */
export default function EditCompanyModal() {
  const {
    state: {
      showEditModal,
      currentEditingCompany,
    },
    dispatch,
  } = React.useContext(CompaniesContext);

  const [errors, setErrors] = React.useState({});

  const overlayRef = React.useRef();
  const modalRef = React.useRef();

  const dismiss = e => {
    e && e.preventDefault();
    setErrors({});
    dispatch({ type: 'dismissModal' });
  };

  const modalDismiss = e => {
    e && e.preventDefault();
    e.target === modalRef.current && dismiss();
  };

  React.useEffect(() => {
    if (showEditModal) {
      $(modalRef.current).fadeIn();
      $(overlayRef.current).fadeIn();
    } else {
      $(overlayRef.current).fadeOut();
      $(modalRef.current).fadeOut({ complete: () => dispatch({ type: 'dismissModal' }) });
    }
  }, [showEditModal, dispatch]);

  const handleInputChange = e => {
    e && e.preventDefault();

    setErrors({});

    const { name, value } = e.target;

    currentEditingCompany[name] = value;
  };

  const saveCompany = e => {
    e && e.preventDefault();

    if (currentEditingCompany.id) {
      updateCompany(currentEditingCompany).then(() => {
        dispatch({ type: 'companyUpdated', payload: currentEditingCompany });
        dismiss();
      }).catch(error => {
        setErrors(error.response.data);
      });
    } else {
      createCompany(currentEditingCompany).then(response => {
        dispatch({ type: 'companyCreated', payload: { id: response.data.id, ...currentEditingCompany } });
        dismiss();
      }).catch(error => {
        setErrors(error.response.data);
      });
    }
  };

  const removeMember = (e, member) => {
    e && e.preventDefault();
    dispatch({ type: 'removeMember', payload: member });
  };

  return (
    <div>
      <div className="modal-overlay" role="region" ref={overlayRef} onClick={dismiss} />
      <div className="modal --large" tabIndex="-1" role="dialog" ref={modalRef} onClick={modalDismiss}>
        <article>
          <header>
            <h4>
              <span>{`${currentEditingCompany.id ? 'Editing' : 'Creating'} company`}</span>
            </h4>
          </header>
          <section className="modal-columnar-container">
            <section>
              <p className={`form-group ${errors.name && 'has-error'}`}>
                <label htmlFor="company-name">
                  Company name
                  <input
                    id="company-name"
                    type="text"
                    name="name"
                    value={currentEditingCompany.name}
                    onChange={handleInputChange}
                    placeholder="Company name"
                  />
                </label>
                {errors.name && <span className="help-block">{errors.name}</span>}
              </p>
              <p className={`form-group ${errors.summary && 'has-error'}`}>
                <label htmlFor="summary">
                  Company summary
                  <textarea
                    id="summary"
                    type="text"
                    name="summary"
                    value={currentEditingCompany.summary}
                    onChange={handleInputChange}
                    placeholder="Company summary"
                    maxLength={450}
                  />
                </label>
                {errors.summary && <span className="help-block">{errors.summary}</span>}
              </p>
              <p className={`form-group ${errors.administrator_email && 'has-error'}`}>
                <label htmlFor="administrator-email">
                  Administrator email
                  <input
                    id="administrator-email"
                    type="text"
                    name="administratorEmail"
                    value={currentEditingCompany.administratorEmail}
                    onChange={handleInputChange}
                    placeholder="Administrator email"
                  />
                </label>
                {errors.administrator_email && <span className="help-block">{errors.administrator_email}</span>}
              </p>
              <p className={`form-group ${errors.website_url && 'has-error'}`}>
                <label htmlFor="website-url">
                  Company website
                  <input
                    id="website-url"
                    type="text"
                    name="websiteUrl"
                    value={currentEditingCompany.websiteUrl}
                    onChange={handleInputChange}
                    placeholder="Company website url"
                  />
                </label>
                {errors.website_url && <span className="help-block">{errors.website_url}</span>}
              </p>
            </section>
            <section>
              <div className={`form-group ${errors.members && 'has-error'}`}>
                <MemberTitle>Team Members</MemberTitle>
                <Members>
                  {currentEditingCompany.members.map(member => (
                    <Member key={member.id}>
                      {`${member.name} (${member.role})`}
                      <a href="#" onClick={e => removeMember(e, member)}>Remove</a>
                    </Member>
                  ))}
                </Members>
                <MemberSearchControl />
                {errors.members && <span className="help-block">{errors.members}</span>}
              </div>
            </section>
          </section>
          <footer>
            <button type="button" className="btn btn-secondary" onClick={dismiss}>Cancel</button>
            <button type="button" className="btn btn-primary" onClick={saveCompany}>Save</button>
          </footer>
        </article>
      </div>
    </div>
  );
}
/* eslint-enable complexity */
